import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from '@/store';
import App from './App';
import '@/styles/global.scss';

const antdTheme = {
  token: {
    colorPrimary: '#29b6c6',
    borderRadius: 4,
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  },
};

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <ConfigProvider theme={antdTheme}>
        <App />
      </ConfigProvider>
    </Provider>
  </StrictMode>,
);
